import { render, staticRenderFns } from "./ArticleHeadlinesSection.vue?vue&type=template&id=8aff2350&scoped=true"
import script from "./ArticleHeadlinesSection.vue?vue&type=script&lang=ts"
export * from "./ArticleHeadlinesSection.vue?vue&type=script&lang=ts"
import style0 from "./ArticleHeadlinesSection.vue?vue&type=style&index=0&id=8aff2350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aff2350",
  null
  
)

export default component.exports